var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.523,
    height: 102.695,
    viewBox: "0 0 48.523 102.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00b8f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268.155 -336.846)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M280.04,377.272A21.362,21.362,0,1,1,310.5,353.411l.378-.029,5.8,34.655S290.112,384.771,280.04,377.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.491,437.729a12.137,12.137,0,0,1-4.08-16.579,11.854,11.854,0,0,1,11.651-5.6c7.012-.4,20.563,6.485,20.563,6.485l-13.451,14.391-.161-.128a11.881,11.881,0,0,1-8.172,3.238A12.061,12.061,0,0,1,288.491,437.729Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionWater);
export default __webpack_public_path__ + "static/media/section-water.53bdbd0802d187ac94cca66837d452bd.svg";
export { ForwardRef as ReactComponent };